import * as React from 'react'
import Select from 'react-select'
import { FormGroup } from '@blueprintjs/core'
import { ListingStrategy } from '../../types/api'

interface Props {
  strategyId: number
  strategies: ListingStrategy[]
  setStrategyId: (strategyId: number) => void
  maybe: boolean
  label: string
  labelInfo?: any
}

export const StrategyPicker: React.FC<Props> = props => {
  if (!props.strategies) return null

  if (props.maybe) {
    // Hide this if there is only 1 available (b/c they don't need to worry about it).
    // Show it if there are zero results, so that they can clearly see "No results found" + icon.
    if (props.strategies.length === 1) {
      return null
    }
  }

  const select = (
    <Select
      className="maybe-dark-select"
      disabled={props.strategies.length === 1}
      onChange={props.setStrategyId}
      value={props.strategyId}
      options={props.strategies.map(s => ({ label: s.name, value: s.id }))}
      simpleValue
      clearable={false} // Express List requires people to use a strategy. Also avoids having to partially reset the form state.
    />
  )

  if (props.label) {
    return (
      <div data-testid="strategy-formgroup">
        <FormGroup labelInfo={props.labelInfo} label={props.label}>
          {select}
        </FormGroup>
      </div>
    )
  }
  return select
}
